import React, { useEffect, useState } from "react";
import { SpinnerCircular } from "spinners-react";
import Hero from "../components/HomeComponents/Hero";
import Features from "../components/HomeComponents/Features";
import Navbar from "../components/HomeComponents/Navbar";
import Footer from "../components/HomeComponents/Footer";
import { routes } from "../helper/misc";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../helper/auth";
import SEO from "../components/Seo/Seo";
import payments from "../api/payments";
import { toast } from "react-hot-toast";

function Home() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handlePaymentEnd = async (reference) => {
    setIsLoading(true);
    try {
      await payments.verifyPurchase({
        transaction_reference: reference,
      });
      setIsLoading(false);
      toast.success(`Purchase was successful`);
      if (auth?.user) {
        navigate(`/transactions/${reference}/receipt`, { replace: true });
      }
    } catch (e) {
      setIsLoading(false);
      toast.error("Error", "Failed to verify payment.");
    }
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    // Extract query parameters
    const trxref = urlSearchParams.get("trxref");
    if (auth?.user && !trxref) {
      if (auth.meterOwnerships?.length > 0) {
        navigate(routes.buy_water);
      } else {
        navigate(routes.manage_meters);
      }
    }
    if (trxref) {
      handlePaymentEnd(trxref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user]);

  return (
    <div>
      <SEO type={"homepage"} title="Home" />
      {isLoading ? (
        <span className="flex align-center justify-center h-screen">
          <SpinnerCircular
            size={50}
            thickness={96}
            speed={100}
            color="rgba(255, 255, 255, 1)"
            secondaryColor="rgba(16, 156, 241, 1)"
          />
        </span>
      ) : (
        <>
          <Navbar />
          <Hero />
          <Features />
          {/* <Testimonials /> */}
          <Footer />
        </>
      )}
    </div>
  );
}

export default Home;
